import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import LineBtn from "../../components/Button/LineBtn";
import LineBox from "../../components/DefaultStyles/LineBox";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import DropDown, { OptionType } from "../../components/Filters/DropDown";
import Search from "../../components/Filters/Search";
import Pagination from "../../components/Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import { useApi } from "../../hooks/useApi";
import { Filters, TotalCount } from "./UserInfo";
import DotStatus from "../../components/DefaultStyles/DotStatus";
import Blank from "../../components/DefaultStyles/Blank";
import BlackListModal from "../../components/pages/Users/UserDetail/BlackListModal/BlackListModal";
import ExcelDownload from "../../components/DefaultStyles/ExcelDownload";
import Loader from "../../components/DefaultStyles/Loader";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import { authType } from "../Login";
import { useNavigate } from "react-router-dom";
import { getThousandComma } from "../../Api/ApiCommon";
import { getEllipsis } from "../../ApiTS/ApiCommonTS";
import RadioBtn from "../../components/Button/RadioBtn";

export interface IBlackListInfo {
  uid: string;
  name: string;
  nickname: string;
  create?: boolean;
  join?: boolean;
  withdraw?: boolean;
  comforming_withdraw?: boolean;
  chat?: boolean;
  reason?: string;
  startDay?: string;
  endDay?: string;
  writer?: string;
}

export const blackListPageState = atom<number>({
  key: "blackListPageState",
  default: 0,
});

export default function BlackList() {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();
  const [savedPage, setSavedPage] = useRecoilState<number>(blackListPageState);

  const [page, setPage] = useState(savedPage);
  const [searchValue, setSearchValue] = useState<string | undefined>("");
  const [dropDownValue, setDropDownValue] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [blackListInputModal, setBlackListInputModal] = useState(false);
  const [blacklistData, setBlacklistData] = useState<IBlackListInfo>();
  const [blackListViewModal, setBlackListViewModal] = useState(false);
  const [blacklist_viewType, setBlacklistViewType] = useState<0 | 1>(0); //(1: 종료된 대상만, 0: 종료되지 않은 대상만)

  const { response, fetchData, loading } = useApi({
    method: "get",
    url:
      searchValue !== ""
        ? `black-list?page=${page}&size=10&${dropDownValue?.value}=${searchValue}&isExpired=${blacklist_viewType}`
        : `black-list?page=${page}&size=10&isExpired=${blacklist_viewType}`,
  });

  const tableHead = [
    "NO",
    "UID_이름_닉네임",
    "파티 생성",
    "파티 가입",
    "인출",
    "채팅",
    "인출 확인 중",
    "내용",
    "시작일",
    "종료일",
    "상세",
  ];

  useEffect(() => {
    setSavedPage(0);
  }, []);

  useEffect(() => {
    if (searchValue !== "") {
      setPage(0);
    }
  }, [searchValue]);

  return (
    <>
      <PageTitle title="블랙리스트" />

      <SpaceBetween>
        <>
          <Filters marginBottom={0}>
            <DropDown
              isDisabled={false}
              setDropDownValue={setDropDownValue}
              dropdownValue={dropDownValue}
            />

            <Search
              placeholder="입력"
              setSearchValue={setSearchValue}
              isDisabled={dropDownValue?.value === ""}
              pageResetEvent={() => setPage(0)}
              inputType={
                dropDownValue?.value === "phone" ||
                dropDownValue?.value === "uid"
                  ? "number"
                  : undefined
              }
            />
          </Filters>

          <LineBtn
            btnText="블랙리스트 추가"
            icon="sentiment_very_dissatisfied"
            btnClickEvent={() => setBlackListInputModal(true)}
            disabled={!auth?.black}
          />
        </>
      </SpaceBetween>

      <Blank blankHeight={12} />
      <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
        <RadioBtn
          label="현재 유저"
          clickEvent={() => setBlacklistViewType(0)}
          check={blacklist_viewType === 0}
          noTooltip={true}
        />
        <RadioBtn
          label="종료 유저"
          clickEvent={() => setBlacklistViewType(1)}
          check={blacklist_viewType === 1}
          noTooltip={true}
        />
      </div>
      <LineBox>
        <Table tableHeadData={tableHead} tableMinWidth={1000}>
          <>
            {response?.data?.items?.map((d: IBlackListInfo, index: number) => {
              return (
                <TableBody key={index}>
                  <TableBodyItem>
                    {" "}
                    {response?.data?.totalCount - (page * 10 + index)}
                  </TableBodyItem>
                  <TableBodyItem
                    clickable={true}
                    onClick={() => {
                      setSavedPage(page);
                      navigate(`/users/info/${d?.uid}`);
                    }}
                    isKeepAll={true}
                  >
                    {d?.uid}_{d?.name}_{d?.nickname}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.create ? (
                      <DotStatus text="제한" size="sm" isBold={true} />
                    ) : (
                      <DotStatus
                        text="가능"
                        size="sm"
                        color="#aaaaaa"
                        isBold={true}
                      />
                    )}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.join ? (
                      <DotStatus text="제한" size="sm" isBold={true} />
                    ) : (
                      <DotStatus
                        text="가능"
                        size="sm"
                        color="#aaaaaa"
                        isBold={true}
                      />
                    )}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.withdraw ? (
                      <DotStatus text="제한" size="sm" isBold={true} />
                    ) : (
                      <DotStatus
                        text="가능"
                        size="sm"
                        color="#aaaaaa"
                        isBold={true}
                      />
                    )}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.chat ? (
                      <DotStatus text="제한" size="sm" isBold={true} />
                    ) : (
                      <DotStatus
                        text="가능"
                        size="sm"
                        color="#aaaaaa"
                        isBold={true}
                      />
                    )}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.comforming_withdraw ? (
                      <DotStatus text="제한" size="sm" isBold={true} />
                    ) : (
                      <DotStatus
                        text="가능"
                        size="sm"
                        color="#aaaaaa"
                        isBold={true}
                      />
                    )}
                  </TableBodyItem>
                  <TableBodyItem>{getEllipsis(d?.reason!, 18)}</TableBodyItem>
                  <TableBodyItem>
                    {dayjs(d?.startDay)?.format("YYYY-MM-DD HH:mm")}
                  </TableBodyItem>
                  <TableBodyItem>
                    {dayjs(d?.endDay)?.format("YYYY-MM-DD HH:mm")}
                  </TableBodyItem>
                  <TableBodyItem>
                    <LineBtn
                      btnText="상세"
                      btnClickEvent={() => {
                        setBlacklistData(d);
                        setBlackListViewModal(true);
                      }}
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0,
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      <ExcelDownload
        disabled={response?.data?.items?.length < 1}
        tableHead={tableHead?.slice(1, tableHead?.length)}
        pushedData={(e: any) => {
          return [
            `${e.uid}_${e.name}_${e.nickname}`,
            e.create ? "가능" : "제한",
            e.join ? "가능" : "제한",
            e.withdraw ? "가능" : "제한",
            e.chat ? "가능" : "제한",
            e?.reason,
            dayjs(e?.startDay)?.format("YYYY-MM-DD HH:mm"),
            dayjs(e?.endDay)?.format("YYYY-MM-DD HH:mm"),
          ];
        }}
        dataUrl={
          searchValue !== ""
            ? `black-list?page=0&size=1000&${dropDownValue?.value}=${searchValue}`
            : `black-list?page=0&size=1000`
        }
      />

      {/* 블랙리스트 추가 모달 */}
      {blackListInputModal && (
        <BlackListModal
          closeEvent={() => setBlackListInputModal(false)}
          confirmEvent={() =>
            fetchData({
              method: "get",
              url:
                searchValue !== ""
                  ? `black-list?page=${page}&size=10&${dropDownValue?.value}=${searchValue}`
                  : `black-list?page=${page}&size=10`,
            })
          }
          type="input"
        />
      )}

      {/* 블랙리스트 보기 모달 */}
      {blackListViewModal && (
        <BlackListModal
          closeEvent={() => setBlackListViewModal(false)}
          confirmEvent={() =>
            fetchData({
              method: "get",
              url:
                searchValue !== ""
                  ? `black-list?page=${page}&size=10&${dropDownValue?.value}=${searchValue}`
                  : `black-list?page=${page}&size=10`,
            })
          }
          blacklistData={blacklistData}
          type="view"
        />
      )}

      {loading && <Loader />}
    </>
  );
}
